import React from 'react';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { queryClient, queryKeys } from 'modules/LeadsV2/config/queryClient';
import { useLeadDetails } from '../hooks/useLeadDetails';
import LeadDataHandler from '../Context/LeadContext';
import AddNewLead from './AddLead';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';

export default function AddLeadPage() {
  const { leadDetails } = useLeadDetails();

  const history = useHistory();
  const { id } = useParams();
  const handleCloseLead = (action) => {
    history.replace('/leads');
    if (action === 'created') {
      queryClient.invalidateQueries({ queryKey: queryKeys.leads.all });
    }
  };

  return (
    <LeadDataHandler>
      <div className="container-fluid task-wrap">
        <GlobalLoader />
        {(leadDetails || !id) && <AddNewLead handleClose={handleCloseLead} selectedLead={leadDetails} />}
      </div>
    </LeadDataHandler>
  );
}
